import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { getComponentEntryQueryKey } from './query.get.js';
import { shareComponentEntryRequest } from './request.share.js';

function useShareComponentEntryMutation() {
  const client = useQueryClient();
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  return useMutation(mutation(client, notifier, user));
}
const mutation = (client, notifier, user) => {
  return {
    mutationKey: ["component-framework/share-component-entry"],
    mutationFn: async ({
      entry,
      message
    }) => {
      if (!user) {
        return;
      }
      if (user.id !== entry?.envelope.userID) {
        console.warn("useFinishComponentEntryMutation(): userId does not own entry.");
        return;
      }
      if (!entry) {
        throw new Error("useShareComponentEntryMutation().mutate: No componentEntry provided");
      }
      return await shareComponentEntryRequest(user, entry, message);
    },
    onMutate: ({
      entry
    }) => {
      if (!entry) {
        return;
      }
      const sharedEntry = entry?.envelope ? {
        ...entry,
        envelope: {
          ...entry.envelope,
          shared: true,
          modified: Date.now() / 1000
        }
      } : undefined;
      client.setQueryData(getComponentEntryQueryKey(entry.entryKey), () => sharedEntry);
      return undefined;
    },
    onSuccess: result => {
      if (!result) {
        return;
      }
      notifier.notify({
        id: "component-framework.share-component-entry",
        type: "success",
        body: "Din besvarelse er blevet delt"
      });
    },
    onError: () => {
      notifier.notify({
        id: "component-framework.share-component-entry.error",
        type: "error",
        body: "Noget gik galt da vi forsøgte at dele din besvarelse. Prøv igen om lidt."
      });
    }
  };
};

export { useShareComponentEntryMutation };
//# sourceMappingURL=mutation.share.js.map
